// for general Cards:
export const QUANTITIES = [
  20,
  30,
  40,
  50,
  60,
  70,
  80,
  90,
  100,
  110,
  120,
  130,
  140,
  150,
  160,
  170,
  180,
  190,
  200,
  210,
  220,
  230,
  240,
  250,
  260,
  270,
  280,
  290,
  300,
  310,
  320,
  330,
  340,
  350,
  360,
  370,
  380,
  390,
  400,
];
export const DEFAULT_QUANTITY = 100;

const getOptionsWithoutProof = () =>
  QUANTITIES.map(quantity => ({
    label: quantity.toString(),
    value: quantity,
  }));
const getOptionsWithProof = () => {
  const options = [...getOptionsWithoutProof()];
  options.unshift({ label: '1 (Proof)', value: 1 });

  return options;
};

export const QUANTITY_OPTIONS = getOptionsWithProof();

export const DEFAULT_PAPER_TYPE_VALUE = 'smooth'; // use smooth as default to prevent bug with foil cards that dont have eggshell paper-type as an option
export const DEFAULT_SHAPE_VALUE = 'square';

export const ALL_FILTER_COLORS = [
  'BLACK',
  'BLUE',
  'BROWN',
  'GREEN',
  'GREY',
  'ORANGE',
  'PINK',
  'PURPLE',
  'RED',
  'WHITE',
  'YELLOW',
];

export const SEO_COLORS = [
  'BLUE',
  'DUSTY_BLUE',
  'ROYAL_BLUE',
  'NAVY',
  'BLACK',
  'RED',
  'BURGUNDY',
  'WHITE',
  'PURPLE',
  'LAVENDER',
  'PLUM',
  'PINK',
  'ROSE',
  'DUSTY_ROSE',
  'CORAL',
  'PEACH',
  'GREEN',
  'EMERALD_GREEN',
  'TEAL',
  'ORANGE',
  'YELLOW',
  'GREY',
  'BROWN',
  'BEIGE',
  // 'GOLD',
  // 'SILVER',
  // 'ROSE_GOLD',
];

export const TEXT_ALIGNMENT_OPTIONS = ['LEFT', 'CENTER', 'RIGHT'];
export const BACK_PRINTING_PRICE = 35;

export const PAGES = ['FRONT', 'INSIDE', 'WRITE', 'BACK', 'RSVP', 'RSVP ENVELOPE', 'ENVELOPE'];
export const PAGE_URLS = {
  FRONT: 'detailFront',
  INSIDE: 'detailInside',
  WRITE: 'detailWrite',
  ASSIGN: 'detailAssign',
  BACK: 'detailBack',
  RSVP: 'rsvp',
  'RSVP ENVELOPE': 'rsvpEnvelope',
  ENVELOPE: 'envelope',
};

// for PLP:
export const REGULAR_COLORS = [
  'BLUE',
  'GREEN',
  'BLACK',
  'PINK',
  'PURPLE',
  'WHITE',
  'RED',
  'BEIGE',
  'GREY',
  'ORANGE',
  'YELLOW',
  'BROWN',
];

export const BASE_URL = '/wedding-planning';

export const CARD_SIZES = {
  petite: 'petite',
  magnet: 'magnet',
  classic: '5x7',
  folded: 'folded-petite',
  postcard: 'postcard',
  tall: '4x8',
  smallFolded: 'folded-placecard-standard',
};

export const MIN_DPI = 300;

export const HIGHEST_ALLOWED_MIN_REQUIREMENT = 1200;

export const MAX_CARD_DIMENSION_INCHES = {
  [CARD_SIZES.petite]: 5.5,
  [CARD_SIZES.magnet]: 5.5,
  [CARD_SIZES.classic]: 7,
  [CARD_SIZES.folded]: 5.5, // height is smaller than width when folded, so use width
  [CARD_SIZES.postcard]: 5.5,
  [CARD_SIZES.tall]: 8,
  [CARD_SIZES.smallFolded]: 3.5,
};

export const SEASONS = ['Fall', 'Winter', 'Spring', 'Summer'];
